interface Props {
  onBack: () => void;
}

export function HowToPlay({ onBack }: Props) {
  return (
    <div className="stack" style={{ height: '100%' }}>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h2 className="title" style={{ fontSize: '1.6rem' }}>
          How to Play
        </h2>
        <button type="button" className="btn btn-ghost" onClick={onBack}>
          Back
        </button>
      </div>
      <div className="panel stack">
        <p>
          Drive your matatu for <strong>60 seconds</strong>. Stay alive, collect fare tokens, and chase a
          high score.
        </p>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.55 }}>
          <li>
            <strong>Mobile:</strong> swipe or tap ◀ ▶ to change lanes. Hold BOOST for a burst of speed.
          </li>
          <li>
            <strong>Desktop:</strong> ← → or A/D to steer. Space to boost. Esc / P to pause.
          </li>
          <li>Avoid cars, potholes, cones and bodas. You can take {3} hits.</li>
          <li>Near misses and fare combos boost your score.</li>
          <li>Daily Challenge uses a date seed (personal best on this device).</li>
        </ul>
      </div>
    </div>
  );
}
